import React from 'react'
import { Skeleton } from '@material-ui/lab'

import * as S from './emailTemplatesSkeleton.styles'

export const EmailTemplatesSkeleton = () => {
    return (
        <S.EmailTemplatesWrapper>
            <S.Header>
                <S.Title>
                    <Skeleton width={120} />
                </S.Title>

                <S.Description>
                    <Skeleton width={240} />
                </S.Description>
            </S.Header>

            <S.TemplatesList>
                <S.TemplatesListItem>
                    <S.TemplateTitle>
                        <Skeleton width="100%" />
                    </S.TemplateTitle>
                </S.TemplatesListItem>
            </S.TemplatesList>
        </S.EmailTemplatesWrapper>
    )
}
